import { render, staticRenderFns } from "./DiscountStatus.vue?vue&type=template&id=cefef3f4&"
import script from "./DiscountStatus.vue?vue&type=script&lang=js&"
export * from "./DiscountStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports